export enum SaleStatus {
    All = 'all-status',
    StockIn = 'stock_in',
    TempOut = 'temp_stock_out',
    Suspended = 'suspended',

    StockIn2 = 'stock_in2',
    TempOut2 = 'temp_stock_out2',
    Suspended2 = 'suspended2',
}
